import React from "react";
import "./ActionInfoAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";

export const ActionInfoAICard = ({ message, title, onSuggestedQuestionClick }) => {
  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  const suggestedQuestions = (message.suggested_questions || []).slice(0, 2);

  return (
    <div className="action-info-ai-card ai-left">
      <div className="action-info-ai-header">
        <img src={aiChatlogo} alt="Axon AI" className="action-info-ai-logo" />
        <div className="action-info-ai-title">
          <span>{title || "Axon AI"}</span>
          <div className="action-info-time">{`${day} ${time}`}</div>
        </div>
      </div>
      <div className="action-info-ai-bubble-inner">
        {message.text}
        {suggestedQuestions.length > 0 && (
          <div className="action-info-suggested-questions">
            <span className="suggested-questions-label">Suggested Questions</span>
            <div className="suggested-questions-list">
              {suggestedQuestions.map((question, index) => (
                <button
                  key={index}
                  className="suggested-question-item"
                  onClick={() => onSuggestedQuestionClick?.(question)}
                >
                  {question}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
